// Product page behavior: gallery, case-color + storage pickers, sticky-bar summary.
(function () {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // ---------- Gallery ----------
  const mainImg = $('#galleryMain');
  const thumbs = $$('.gallery-thumbs .thumb');
  thumbs.forEach((btn) => {
    btn.addEventListener('click', () => {
      const src = btn.dataset.src;
      if (!src) return;
      thumbs.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');
      if (mainImg && mainImg.src !== src) {
        mainImg.style.opacity = '0';
        requestAnimationFrame(() => {
          mainImg.src = src;
          mainImg.addEventListener('load', () => (mainImg.style.opacity = '1'), { once: true });
        });
      }
    });
  });

  // ---------- Free case color ----------
  const swatches = $$('.swatch');
  const colorLabel = $('#colorLabel');
  swatches.forEach((s) => {
    s.addEventListener('click', () => {
      swatches.forEach((x) => {
        x.classList.remove('is-active');
        x.setAttribute('aria-checked', 'false');
      });
      s.classList.add('is-active');
      s.setAttribute('aria-checked', 'true');
      if (colorLabel) colorLabel.textContent = s.dataset.color || '';
      updateSummary();
    });
  });

  // ---------- Storage ----------
  $$('.option input[type=radio]').forEach((input) => {
    input.addEventListener('change', () => {
      const group = input.name;
      $$(`input[name="${group}"]`).forEach((i) => i.closest('.option').classList.remove('is-active'));
      input.closest('.option').classList.add('is-active');
      updateSummary();
    });
  });

  // ---------- Summary (mobile sticky text) ----------
  // #mobilePriceTag is owned by the Storefront-API price script in
  // main-product.liquid. This stale handler used to hardcode "$342 · 128GB"
  // and stomp the real (discounted) price — now a no-op so swatch/storage
  // clicks don't clobber it.
  function updateSummary() {}
  updateSummary();
})();
